const TDDB = {
  blogs: [
    {
      "id": 1,
      "title": 'Riyadh – Al-Masmak Palace Tower',
      "img": 'https://media.gettyimages.com/photos/masmak-fortress-picture-id1262189989?s=2048x2048',
      "body": `The Masmak Palace is a tourists’ favorite and a must-visit destination in the capital city of Saudi Arabia.
       Not only do Saudis and expatriates appreciate the majesty of this vast architectural wonder, but it draws interest 
       from across the world as well. However, while we all know about the Masmak Palace and most of us have paid a visit 
       to it at least once, we often overlook the secrets this monument has in store for us. So, here are some facts that
       you probably did not know about the Masmak Palace that glorifies the streets of Riyadh. In fact, in the heart of Riyadh’s 
       old quarters, Masmak Fort is a magnificent citadel that takes us back to the history of Saudi Arabia. This is the fort 
       stormed by the late King Abdul Aziz Ibn Saud in 1902, creating a turning point in the history of the Arabian peninsula. 
       You can still see his spearhead embedded in its wooden gate. Today, Masmak Palace is an acute and virtually official symbol 
       of the pivotal rise of the Saudi nation. An episode dramatically recreated in a short film that plays in Masmak’s museum tells 
       the historic story even today. Amid its halls and rooms displaying photographs, weapons and armor, there is a plaque commemorating
       Saudi Arabia’s national day that refers to the late King Abdul Aziz. The Masmak Fort popularly known as Qasr Al-Masmak stands today 
       as a testament to the late King Abdul Aziz’s bravery that led to the reunification of Saudi Arabia.` ,
      "datecreated": '2020-01-28',
      "category": 'Culture',
      "comments": [
        {
          "id": 1,
          "title": 'Amazaing as useual',
          "username": 'Alex',
          "img": 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png',
          "body": 'I enjoyed reading this blog, thanks. I can not wait to read the next blog!',
          "datecreated": '2020-01-29'
        },
        // new comments information added here 
      ]
    },
    {
      "id": 2,
      "title": 'Riyadh – Red Sand Dunes',
      "img": 'http://2.bp.blogspot.com/-6ItXR7TY1oI/VDg8dAT44EI/AAAAAAAACNw/RWded8AtOBE/s1600/37.jpg',
      "body": `Red Sand is one of the most popular weekend destination among expats and locals
       where you can found in the dessert at north west Riyadh, from his stunning beauty of a pristine 
       red sand and along side of  nice sceneries, a form of Canyon mountains expressing how we must love
       the nature and care for them until many generation can also experience the unforgettable memories, 
       while we're still here in Saudi. And for those who is planning to visit Riyadh, this place a must visit 
       and include to your itinerary list. Planning a trip to the Red Sand is better at early morning before the 
       sunrise come's up or sunset  and the activities that you can enjoy there, one is to ride  ATB motors and that 
       will cost you for only 30 riyals per hour, and you will able to explore the whole beautiful sand dunes by enjoying 
       the majestic creations of our creator. And I'm sure taking photos, having picnics and soul searching? is also will makes 
       you and your friends love the place.`,
      "datecreated": '2020-02-10',
      "category": 'Nature',
      "comments": [
        {
          "id": 1,
          "title": `I'm BACK!!`,
          "username": 'Mystery Guy',
          "img": 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png',
          "body": `First to comment, LOL! No need for clapping everyone :) I'm kidding you can clap`,
          "datecreated": '2020-02-12'
        },
        {
          "id": 2,
          "title": `THANK YOU SO MUCH`,
          "username": 'Steve',
          "img": 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png',
          "body": 'I can not wait to vist this place, thank you as always.',
          "datecreated": '2020-03-12'
        }
        // new comments information added here 
      ]
    },
    {
      "id": 3,
      "title": 'Jeddah - The Floating Mosque',
      "img": 'https://media.gettyimages.com/photos/the-floating-mosque-or-masjid-bibi-fatima-mecca-province-jeddah-saudi-picture-id1129844826?s=2048x2048',
      "body": `It is a long established fact that a reader will be distracted by 
          the readable content of a page when looking at its layout.The point of
           using Lorem Ipsum is that it has a more- or - less normal distribution of letters,
  as opposed to using, making it look like readable English.
Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model.`,
      "datecreated": '2017-06-10',
      "category": 'Culture',
      "comments": [
        {
          "id": 1,
          "title": ` Did you miss me?`,
          "username": 'Mystery Guy is back!',
          "img": 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png',
          "body": 'Well I guess the first comment position is for me now. Do I get any prize?',
          "datecreated": '2017-06-12'
        },
        // new comments information added here 
      ]
    },
    {
      "id": 4,
      "title": 'Al Madinah - Madain Saleh',
      "img": 'https://media.gettyimages.com/photos/alfareed-madain-saleh-saudi-arabia-picture-id1142042556?s=2048x2048',
      "body": `Mada’in Saleh, not far from al-Ula (22 km), was known as al-Hijr, or Hegra, by the Nabataean people who carved
       its magnificent tombs into the golden Quweira sandstone outcrops. The delicate details on the entrance portals and the 
       smooth surfaces of its 111 tomb façades reflect the great skills of the masons of their time. The splendor of the natural
       setting here must have reminded the Nabataeans of their capital, Petra, hewn into the rosey sandstone cliffs to the north 
       in modern-day Jordan. It is no wonder that they chose this very spot to build their second city, Hegra. Based on the many 
       dated tomb inscriptions, Hegra thrived between 1 BCE -74 CE. The Nabataeans began as pastoral nomads, raising their sheep, goats,
       and camels in the desert as so many other Arabian tribes have done through the millennia.`,
      "datecreated": '2018-06-10',
      "category": 'Culture',
      "comments": [
        {
          "id": 1,
          "title": `I love this website so much!`,
          "username": 'Izzy',
          "img": 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png',
          "body": 'Thanks alot, this is was really helpful, Could you write blog about Hail city?',
          "datecreated": '2018-07-10'
        }
        // new comments information added here 
      ]
    },
    {
      "id": 5,
      "title": 'Abha – Epic ancient buildings and monkeys',
      "img": 'https://media.gettyimages.com/photos/townscape-and-mountain-range-against-sky-during-sunset-picture-id1176769393?s=2048x2048',
      "body": `The picturesque city of Abha is located in the fertile mountainous region of Asir in the southwestern part of the Kingdom.
       Here clouds seem to sit on top of the mountains for most of the year. Abha can, therefore, rightly be called a ‘capital of clouds’
       where their meeting with the delightful and charming places increased the city’s beauty coupled with the cool air that the region enjoys 
       throughout the year. Situated at high altitude of 2,270 meters above the sea level, the city enjoys pleasant weather all year round.
       Abha’s mild climate, natural beauty, historical, social and cultural heritage, its unique agricultural environment, and its particular
       brand of festivals has earned it the title of Arab Tourism Capital a few years ago. The Asir region houses more than 4,275 heritage villages,
       including Rijal Alma, which is expected to be registered in the World Heritage List of UNESCO. Rijal Alma is one of the Kingdom’s most prominent 
       cultural and archaeological destinations and is considered an architectural icon. Asir is also renowned for its stunning scenery such as the woods 
       and forests in Dulghan and Al-Habala, in addition to the spectacular scenery of Al-Sawdah, which has the highest mountains in the Kingdom, 
       including the tallest peak.`,
      "datecreated": '2019-05-10',
      "category": 'Nature',
      "comments": [
        {
          "id": 1,
          "title": `Most useless website ever!!`,
          "username": 'Why day you need this info?',
          "img": 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png',
          "body": 'Who want to visit Saudi Arabia, it sucks!! They only have dessert there and they travel by camel!',
          "datecreated": '2019-08-10'
        },
        {
          "id": 2,
          "title": `Delete the comment above me`,
          "username": 'John?',
          "img": 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png',
          "body": '@Why day you need this info? I think you are missing brain cells',
          "datecreated": '2019-08-15'
        }
        // new comments information added here 
      ]
    },
    {
      "id": 6,
      "title": 'Jeddah - Red Sea Mall',
      "img": 'https://upload.wikimedia.org/wikipedia/commons/3/33/Red_Sea_Mall_1_Jeddah.jpg',
      "body": `The Red Sea Mall has reopened its doors for visitors and shoppers after
       the period of temporary lockdown due to the spread of the Covid-19 pandemic. The center
       has launched an all-out disinfection campaign affecting all its premises and facilities by 
       a specialized company that followed the highest sanitization techniques according to the best 
       international practices. This step comes in line with the Saudi government’s decision to allow 
       shopping malls to resume business under stringent safety directives, while the Red Sea Mall’s management
       has determined the opening hours of the center between 10:00 a.m. and 4:00 p.m. Red Sea Mall has been keen on
       following all procedures and preventive measures while allowing visitors. The body temperature is measured for 
       each new comer at the entrances of the mall, in addition to requiring employees and visitors alike to wear masks
       and gloves during their presence inside the mall and sterilizing their hands at the entrance. The mall has deployed
       various hand sanitizers throughout the center.`,
      "datecreated": '2019-06-10',
      "category": 'Shopping',
      "comments": [
        {
          "id": 1,
          "title": `This website change me life for better!`,
          "username": 'Rebica',
          "img": 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png',
          "body": `I got great deal from this website and I was able to visit Jeddah, everyone needs to use the website IT'S THE BEST!`,
          "datecreated": '2019-06-10'
        }
        // new comments information added here 
      ]
    },
    {
      "id": 7,
      "title": 'Jizan - Mountain villages',
      "img": 'https://www.abouther.com/sites/default/files/2020/09/14/faifa_mountains_.jpg',
      "body": `First of all, in a country where the stereotype landscape is an endless extent
       of sand dunes, Jizan is all about tall green mountains, deep blue sea, virgin islands, 
       and pristine beaches. Jizan and Al-Bahah, the two smallest provinces in Saudi Arabia, 
       are also the only two ones where no desert sand dunes can be found. Instead, Jizan 
       Province has only low white sand dunes along its shore. Then, in a country whose climate 
       is so arid that despite its vast territory has no permanent river reaching the sea, Jizan
        Province benefits from the monsoon which gives two rainy seasons annually where most of 
        the country has barely one. Thanks to these special climatic conditions and its geography,
        Jizan Province hosts green wadis, like the famous Wadi Lajab, and also several hot springs,
        like Bani Malik and Al-Khoubah, that are reputed for their therapeutic qualities. It is 
        also famous for its high-quality production of tropical fruits like mango, figs, and papaya.`,
      "datecreated": '2019-12-10',
      "category": 'Nature',
      "comments": [
        {
          "id": 1,
          "title": `I hope my comment help you`,
          "username": 'John',
          "img": 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png',
          "body": `This is really beautiful, I would love to visit this city. Please write more articles about cities like this.`,
          "datecreated": '2019-12-10'
        }
        // new comments information added here 
      ]
    }
    // new blog information added here 
  ],
  reviews: [
    {
      "id": 1,
      "name": 'Dani angle',
      "avatar": 'https://uifaces.co/our-content/donated/1H_7AxP0.jpg',
      "title": 'Amazing website, 100% recomended!',
      "review": `I truly love this website it's helpful, easy to follow and interactive.
      For anyone whose intersted in visting Saudi Arabi, this website is your best option!`
    },
    {
      "id": 2,
      "name": 'Sara Ti',
      "avatar": 'https://images.unsplash.com/photo-1546539782-6fc531453083?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&ixid=eyJhcHBfaWQiOjE3Nzg0fQ',
      "title": `It's not too late to use this website`,
      "review": `Best webiste ever, very informative, great deal, and fun. 
      What are you waiting for?`
    },
    {
      "id": 3,
      "name": 'Mark sore',
      "avatar": 'https://uifaces.co/our-content/donated/bUkmHPKs.jpg',
      "title": 'Best tourism planner for Saudi Arabia',
      "review": `Do you want to visit Saudi Arabia but you don't know that much,
      you need guidance, trip plans and good deals? I beileve you are at the righ place.`
    }
    // new review details added here 
  ],
  trips: [
    {
      "id": 1,
      "title": 'Dammam - All you need to know',
      "img": 'https://media.gettyimages.com/photos/palm-trees-by-sea-against-sky-during-sunset-picture-id1190781963?s=2048x2048',
      "description": `Boasting endless views of the tranquil Arabian Gulf, Dammam is a modern metropolis that thrives on its coastal 
      location. Although it is known for its lush green parks, airy waterfronts and sandy beaches, it is highly enjoyable in the winter,
      too, with daytime temperatures averaging in the low 20s Celsius during the day and around 10 degrees at night. The region also has a growing
      reputation as an arts, sports and entertainment destination. It is home to the kingdom’s first street-art exhibition, in Al Khobar’s Bayoonya 
      district, and offers a range of cultural hubs and museums as well. Dip into science and innovation at SCITECH, or get your fill of pop culture at
      the quirky Taybeen and Alfelwah and Aljowharah museums. As evening falls, wander the walkways of Dammam's Share Al Hob souq, where you may encounter
      traders, performers and street musicians.`,
      "location": 'Dammam',
      "newprice": 5000,
      "oldprice": 7000,
      "days": '3',
      "nights": '3',
      "plan": [
        {
          "id": 1,
          "title": 'Explore Al Ahsa Qasis',
          "img": 'https://i1.wp.com/www.saudi24news.com/sa/wp-content/uploads/2020/10/5f7f7fb34236047d5e07db3a.jpg?fit=980%2C551&amp;ssl=1',
          "description": `There’s much more to Saudi Arabia than vast ochre deserts. With more than 2.5 million 
          date palm trees blanketing a verdant expanse just inland from Saudi Arabia’s Gulf coast, Al Ahsa is the archetype 
          of a lush desert oasis. And the UNESCO World Heritage-recognized region recently added a new feather to its cap: in October,
          Guinness World Records declared Al Ahsa the largest self-contained oasis in the world. What that means for travelers is that there’s
          plenty to choose from. From hot and cold springs to historic mosques to sweeping panoramic vistas, you’ll find a lot to explore in this
          6,000-year-old oasis, which has long been a gateway to the Arabian Peninsula for travelers from the East. Don’t miss a chance to sample a 
          khalasah date before you leave —locals proudly proclaim it’s one of the world’s best. But while the date farms are an obvious stop on your Al
          Ahsa itinerary, here are some other sites you can’t miss. `,
        },
        {
          "id": 2,
          "title": 'Ralax At Half Moon Bay',
          "img": 'https://www.dbr.sa/wp-content/uploads/2018/12/Aerial-View-DBR-6-e1554538903882.jpg',
          "description": `Relax on the white sands of Half Moon Beach, a scenic crescent-shaped beach on 
          the Persian Gulf coast that stretches on for miles, and a popular recreation spot for local and 
          expat families. Take a dip in the gulf waters, sunbathe on the broad sandy shore, or ride a beach buggy 
          across the dunes. Boasting an amusement park and play areas for kids, the bay is popular with families with 
          children, while facilities such as bathrooms, lockers, and showers are available. Half Moon Beach is just one of
          the many highlights you can arrange to see using our , online itinerary creator Edition. `,
        },
        {
          "id": 3,
          "title": 'Saudi Arabia’s cultural hub',
          "img": 'https://img.theculturetrip.com/1440x807/smart/wp-content/uploads/2019/01/rexfeatures_10035951b.jpg',
          "description": `The iconic monolithic design of the King Abdulaziz Center for World Culture, 
          known as Ithra, has become a symbol of Saudi’s cultural renaissance. The sprawling building
          houses a theater, library, cinema, galleries and museum, alongside a wealth of interactive activities
          for children. The Ithra Journey Tour, a 30-minute guided walk, offers an ideal overview of the complex. `,
        }
        // new day details added here 
      ]
    },
    {
      "id": 2,
      "title": 'Jeddah -  All you need to know',
      "img": 'https://media.gettyimages.com/photos/high-angle-view-of-illuminated-light-trails-on-highway-at-night-picture-id1084266974?s=2048x2048',
      "location": 'Jeddah',
      "description": `Over the years, no Saudi city has been more open to outside influencers such as traders, international artists and Makkah-bound 
      pilgrims than the ancient port of Jeddah. Indeed, the city’s unofficial motto is “Jeddah ghair,” or “Jeddah’s different.” Today, Jeddah is Saudi 
      Arabia’s buzzing cosmopolitan hub, home to gleaming hotels and big-ticket events like the Red Sea International Film Festival, which takes place in 
      late winter. The city’s heart is still intact in Al Balad, the magical historical quarter that has undergone a renaissance in recent years. And the Red
      Sea is still central to it all — for trade, for diving among pristine reefs, and for fishing for Jeddah’s legendary seafood. The city where Eve was laid 
      to rest (according to local lore) is a beguiling mix of old and new, and one that remains gloriously different.`,
      "newprice": 8000,
      "oldprice": 9000,
      "days": '4',
      "nights": '4',
      "plan": [
        {
          "id": 1,
          "title": 'Shop along the Red Sea',
          "img": 'https://pbs.twimg.com/media/CGcEFKVWgAA_GaV?format=jpg&name=large',
          "description": `The Red Sea coast is a stretch of richly varied cultures: from 
          the port city of Jeddah into the fertile mountains of Taif, via the turquoise-fringed 
          coast around Yanbu. The shopping is just as diverse, from the laden stalls of Al Hada’s farm 
          markets to the high-gloss boutiques of Jeddah’s Boulevard. In the northern city of Tabuk, venture
          to Souq Twaheen in the city’s old quarter. Still used by Bedouin nomads, some of the delights on offer 
          include camel saddles and goat-hair tent covers, alongside ornate crafts, dates and trinkets, all sold in
          a gloriously hectic atmosphere.`
        },
        {
          "id": 2,
          "title": 'Discover Al Balad',
          "img": 'https://www.thenationalnews.com/image/policy:1.917834:1569998038/tr01-Oct-Al-Balad.jpg?f=16x9&w=1200&$p$f$w=f66bfef',
          "description": `Jeddah’s UNESCO-listed historical center is one of the kingdom’s most evocative quarters, with narrow alleyways
           between ancient coral-stone merchants’ houses leading to spice-scented souqs and glowing traditional bakeries. Many buildings have 
           been sensitively restored in recent years, including the grand 106-room Nasseef House, where the former king of Saudi Arabia Abdulaziz
          Ibn Saud stayed in 1925 before becoming king of a unified Saudi Arabia. Empty spaces have become quirky cafés or art galleries and mangour
          woodwork workshops, as a district built in the seventh century looks to the future.`,
        },
        {
          "id": 3,
          "title": 'Explore Jeddah’s Corniche',
          "img": 'https://puk.it/wp-content/uploads/2020/01/JeddahCORNICHE_PUK_01.jpg',
          "description": `Jeddah’s 4.2-kilometer corniche has been transformed into a place of piers,
           swimming bays, restaurants and lushly landscaped walking and cycle paths. Jeddah’s winters 
           are mild and dry, with temperatures ranging from 20 to 32 C, making it comfortable to stroll 
           past iconic sculptures. See pieces by the likes of Henry Moore and Joan Miró, which first arrived
          in the city in the 1970s, that are dotted along the waterfront. For many, coming here is about watching 
          the sun set over the Red Sea then seeing the launch of the 300-meter King Fahd’s Fountain, the world’s tallest,
          with its great jet of water lit up until midnight and visible across the city year-round.`,
        },
        {
          "id": 4,
          "title": 'Visit Tayebat City',
          "img": 'https://www.readofia.com/pravi_content/uploads/2020/04/architecture-museum-1024x576.jpg',
          "description": `Jeddah has a rich 2,500-year history of fishing tribes, early Arabian trade and,
           later, pilgrims. The Tayebat City Museum tells this story and that of the wider Arabian peninsula. 
           Built in traditional Hijazi style, with roshan window screens and ornate minarets, the vast complex sprawls
          over four floors and 18 wings, with more than 60,000 items on display. Explore ancient coins and manuscripts, 
          traditional Saudi costumes and a re-creation of the Kaaba, the sacred black cube at the center of Makkah’s Grand Mosque.`,
        }
        // new day details added here 
      ]
    },
    {
      "id": 3,
      "title": 'Tabuk -  All you need to know',
      "img": 'https://media.gettyimages.com/photos/men-sitting-on-rock-formation-picture-id1193721471?s=2048x2048',
      "location": 'Tabuk',
      "description": `Tabuk, the capital city of the Tabuk region in northwestern Saudi Arabia, has long been a resting
       point for Jordanian and Egyptian pilgrims. Its rich culture can be felt in Souq Twaheen, famed for selling patterned
      rugs and goat-hair tent covers. Visitors flock to Tabuk to explore ancient archaeological sites and the setting of the
      story of the prophet Moses, who lived east of the city for a decade. Marking the start of the Saudi Coast, Tabuk’s charming 
      coastal towns, such as Haql and Sharma, offer clear seas and pristine beaches. But there are more terrains to explore: Consider 
      checking out the carved tombs of Maghaer Shuaib in the desert, or the Moses Springs near Maqna, where natural springs flow under
      date palms. Or the stunning Tayeb Al Ism, a valley of steep granite stones separated from the turquoise-fringed Gulf of Aqaba by only
      the road.`,
      "newprice": 5000,
      "oldprice": 6000,
      "days": '3',
      "nights": '3',
      "plan": [
        {
          "id": 1,
          "title": 'Tabuk Castle',
          "img": 'https://pbs.twimg.com/media/DSzSTZjWkAE3Kzx?format=jpg&name=medium',
          "description": `There are spectacular fortresses all around Tabuk, 
          but this imposing castle in the center of town might be the oldest.
          It’s known to date from 1559, though some claim there was a fortress here as 
          early as 3500 B.C. Inside its walls, two mosques are linked by courtyards, stairwells
          and watchtowers, and there’s a small museum detailing the history of the castle and the 
          wider city — from the great explorers who visited, like Ibn Battuta, to the caravans of pilgrims
          who would stop to drink from its wells on their way to Makkah and Medina.`,
        },
        {
          "id": 2,
          "title": 'Al Disah Valley',
          "img": 'https://pbs.twimg.com/media/DYFxFC5XUAAdhQO?format=jpg&name=large',
          "description": `At the crossroads of three valleys south of Tabuk, 
          the wind-sculpted sandstone columns of Wadi Al Disah (Valley of the Palms) 
          look like a mix between the Grand Canyon and Monument Valley in America. While
          much of the landscape is desert, there are oases of pools, tall grasses and palm 
          trees running through canyons, creating photo ops at every turn, especially during 
          glowing sunsets. It’s possible to hike through much of the valley, or visit via a 
          four-wheel-drive vehicle.`,
        },
        {
          "id": 3,
          "title": 'Maghaer Shuaib',
          "img": 'https://media.gettyimages.com/photos/maghaer-shuaib-saudi-arabia-picture-id1043282078?s=2048x2048',
          "description": `The Maghaer Shuaib seems to appear from nowhere in the reddish desert
           west of Tabuk, its elegantly carved façades and tombs built into the sandstone rocks 
           recalling Petra in Jordan and Hegra at AlUla. After he fled Egypt, Moses lived here for
           a decade under the patronage of the prophet Shuaib, who had been impressed by Moses’ chivalry.
           In return, he offered his daughter Zipporah’s hand in marriage, which Moses accepted before returning to Egypt.`,
        }
        // new day details added here 
      ]
    },
    {
      "id": 4,
      "title": 'Asir - All you need to know',
      "img": 'https://media.gettyimages.com/photos/aerial-view-of-a-saudi-arabia-map-on-a-hill-asir-province-abha-saudi-picture-id1129905177?s=2048x2048',
      "location": 'Asir',
      "description": `The southern endpoint of the Red Sea coast, Abha is the culturally rich capital of the Asir region, and a great base for exploring this
       mountainous part of the kingdom. The city has plenty to explore, from the mud-walled Shada Palace, now a museum, to the lake and amusement park by the
      five-star Abha Palace Hotel. There are vibrant traditional markets in Abha and sister city Khamis Mushait, and historic neighborhoods like Al Nasb and Al Basta. 
      More broadly, this is a place to get immersed in the unique culture of the Asir region, whether exploring the Al Muftaha art village or learning about the customs of 
      tribes in the spectacular nearby villages of Al Habala and Rijal Almaa.`,
      "newprice": 5000,
      "oldprice": 7000,
      "days": '3',
      "nights": '3',
      "plan": [
        {
          "id": 1,
          "title": 'Green Mountain',
          "img": 'https://vid.alarabiya.net/images/2018/11/30/d30b02db-2541-4625-a63a-273dd59b22f3/d30b02db-2541-4625-a63a-273dd59b22f3.jpg',
          "description": `One of Saudi Arabia’s more curious landmarks, Jebel Thera — better
           known as the Green Mountain — is a peak in the south of Abha, lit at night by neon 
           green lights that emit a warm emerald glow across the city. The best way to get to the
          summit is by cable car, where there’s a Lebanese restaurant and cafe with a terrace and 
          panoramic views.`,
        },
        {
          "id": 2,
          "title": 'Al Habala',
          "img": 'https://upload.wikimedia.org/wikipedia/commons/e/ec/Living_on_the_verge_of_Habala_Valley.jpg',
          "description": `The hanging village of Al Habala is a curious wonder. 
          A series of sandstone houses perched on the ledge of a sheer cliff, it was 
          built almost 400 years ago by the Qahtan tribe, who reached the village by 
          rope ladder (the name comes from ‘habal’, the Arabic term for rope). 
          They lived here self-sufficiently until the 1980s, working small terraced farms. 
          Today, there’s a cable car to the village from May to October, and visitors are greeted 
          at the top by Qahtani men wearing traditional flower garlands.`,
        },
        {
          "id": 3,
          "title": 'Al Muftaha Village',
          "img": 'https://thenationpress.net/imgs/2020/08/1596358975blobid0.jpg',
          "description": `Abha’s bohemian arts center, Al Muftaha Village is a beautiful little
           quarter around a mosque daubed with calligraphy. Little galleries showcase the work of 
           regional craftspeople and artists, whose work is often colorful and figurative. Walls are
          daubed with bright murals, many nodding to the geometric patterns that Asiri women would
            traditionally paint their homes with. Small museums either side of the mosque tell the story 
           of Abha’s artistic heritage, including how the status of local families was defined by the 
            quality of the murals in their homes.`,
        }
        // new day details added here 
      ]
    },
    {
      "id": 5,
      "title": 'Al Baha - All you need to know',
      "img": 'https://saudisilkroad.com/wp-content/uploads/albaha.jpg',
      "location": 'Al Baha ',
      "description": `A journey to Al Baha is a journey to a different Saudi Arabia. In a kingdom that’s often characterized by ochre
       desert, this high-altitude city is a place of ancient towers, lush forests and winding valleys. The ancient Ghamid and Zahran tribes
      forged a unique cultural identity in the area, building 1,001 stone qasbah lookout towers that are only found here, as well as setting up a bustling souq.
       But the real joy is driving out of the city on hairpin mountain bends, past apricot and pomegranate orchards, into the 40 or so forests that surround the city.
      The road to the famous marble village of Dhee Ayn — through Tolkienesque valleys and past ruined towers — is almost as spectacular as the site itself.`,
      "newprice": 6000,
      "oldprice": 4000,
      "days": '3',
      "nights": '3',
      "plan": [
        {
          "id": 1,
          "title": 'Dhee Ayn',
          "img": 'https://media.gettyimages.com/photos/dhee-ayn-marble-village-aerial-view-albahah-region-al-mukhwah-saudi-picture-id1129905187?s=2048x2048',
          "description": `Built on a white marble outcrop in the epic Bidah Valley, 
          south of Al Baha, Dhee Ayn looks like an Arabian citadel has arrived on a Tuscan hillside.
          Often called the Marble Village, the cuboid buildings were made of stone and slate more than 400
          years ago, and abandoned sometime in the 1980s. Exploring its narrow pathways today is an eerily beautiful
          experience, especially during the golden hours, when the light reflects on the white marble and the colorful
          mountains in the background. `,
        },
        {
          "id": 2,
          "title": 'Raghadan Forest Park',
          "img": 'https://scth.scene7.com/is/image/scth/040-16:crop-760x570?defaultImage=040-16',
          "description": `In the cool Sarawat mountains west of the city, Raghadan Forest 
          Park was once a wilderness area but has been sensitively adapted for visitors, with a
           paved trail up into forested hills populated by impish baboons. From the top of the path, 
           there are beautiful views of the surrounding mountains and valleys, including the winding
            road that leads to Dhee Ayn. Food stalls and barbecues mean it’s possible to do as the 
            locals do, and dine up in the hills as the sun goes down.`,
        },
        {
          "id": 3,
          "title": 'Sheda Village',
          "img": 'https://scth.scene7.com/is/image/scth/sheda_village_1920x1080:crop-760x570?defaultImage=sheda_village_1920x1080',
          "description": `Nestled halfway to the peak of Jebel Mussala Ibrahim is the hidden village 
          of Sheda, offering dramatic views across the green cliffs and valleys of the Sarawat mountains.
          The picturesque drive up its slopes passes ancient, stone-made houses that dot the roadside, offering a glimpse
          of a time and communities past.`,
        }
        // new day details added here 
      ]
    },
    {
      "id": 6,
      "title": 'Taif - All you need to know',
      "img": 'https://orltaif.com/wp-content/uploads/2019/02/Taif.jpg',
      "location": 'Taif',
      "description": `Just reaching Taif is a thrill. From the hollow of Makkah, a beautiful serpentine road winds up 
      through the mountains to the plateau where Taif sits, passing fruit markets, rose farms and deep valleys. Taif is 
      often referred to as the City of Roses, for the famously fragrant flowers that grow in the wadis and mountains around it. 
      It’s also known as Saudi Arabia’s unofficial summer capital. Because of its altitude, Taif is a cool escape from the summer heat, 
      especially in the beautiful nearby mountains of Al Shafa, where baboons frolic in front of plunging valleys. While the roses bloom
      in April, the city really blossoms in August, when the Souq Okaz cultural festival and the Crown Prince Camel Festival are just a
      few of the attractions around town.`,
      "newprice": 5000,
      "oldprice": 4000,
      "days": '3',
      "nights": '3',
      "plan": [
        {
          "id": 1,
          "title": 'Taif’s rose fields',
          "img": 'https://scth.scene7.com/is/image/scth/1920x1080_Fields:crop-760x570?defaultImage=1920x1080_Fields',
          "description": `Every year, Taif turns pink and red, as the city’s famous 30-petal damask roses scent the air.
           In the City of Roses, more than 900 rose farms produce well over 300 million flowers, which are harvested to
          produce the world’s most expensive rose oil, or attar. See the mechanism first-hand with a guided visit to one 
          of the city’s rose factories, or visit Taif’s central market to browse and buy rose-scented oil, water, fragrance 
          and soaps. `,
        },
        {
          "id": 2,
          "title": 'Taif central market',
          "img": 'https://scth.scene7.com/is/image/scth/660x370_7-1:crop-760x570?defaultImage=660x370_7-1',
          "description": `Taif’s central market is a labyrinth of narrow alleys through sand-colored 
          buildings to peaceful plazas. Laid out in themed areas, there are colorful, fragrant sections
          devoted to rich local honey, perfume (especially rose water and oil), Islamic dress and jewelry.
          Street jewelers with blow torches work on silver rings inlaid with Yemini agate, while nearby shops
          sell elaborate body pieces made of gold mined near Medina. Sellers of ghee milk, oud, decorative swords
          and healing herbs are all part of a quintessential Taif experience.`,
        },
        {
          "id": 3,
          "title": 'Al Hada Mountain',
          "img": 'https://scth.scene7.com/is/image/scth/1920x1080_AlHada:crop-760x570?defaultImage=1920x1080_AlHada',
          "description": `High above the valley that runs towards Makkah, Al Hada is a place of comedic baboons, rose fields and
          natural vastness. A curving road sweeps elegantly down the mountainside, as do ancient zig-zagging camel trails. As the sun 
          sets and locals gather at lookout points, the rows of mountains on the horizon are cast in a greyish ombré. Saudi Arabia’s
          longest cable car runs between the mountaintop and the wadi floor, where there’s an aquamarine water park and toboggan slide 
          at the Hijazi-style Al Kar Tourist Village.`,
        }
        // new day details added here 
      ]
    }
    // new trip details added here 
  ],
  packages: [
    {
      "id": 1,
      "title": 'Vacation in Dammam City',
      "img": 'https://media.gettyimages.com/photos/palm-trees-by-sea-against-sky-during-sunset-picture-id1190781963?s=2048x2048',
      "location": 'Saudi Arabia - Dammam',
      "price": 4000,
      "days": 5,
      "people": 3
    },
    {
      "id": 2,
      "title": 'Vacation in Jeddah City',
      "img": 'https://media.gettyimages.com/photos/mosque-by-red-sea-picture-id182500834?s=2048x2048',
      "location": 'Saudi Arabia - Jeddah',
      "price": 5000,
      "days": 5,
      "people": 2
    },
    {
      "id": 3,
      "title": 'Vacation in Jazan City',
      "img": 'https://dynamic-media-cdn.tripadvisor.com/media/photo-o/12/f0/94/64/fayfa-children-play-area.jpg?w=1200&h=700&s=1',
      "location": 'Saudi Arabia - Jazan',
      "price": 4000,
      "days": 5,
      "people": 2
    },
    {
      "id": 4,
      "title": 'Vacation in Tabuk City',
      "img": 'https://media.gettyimages.com/photos/trees-on-landscape-against-sky-picture-id1200272584?s=2048x2048',
      "location": 'Saudi Arabia - Tabuk',
      "price": 7000,
      "days": 3,
      "people": 4
    },
    {
      "id": 5,
      "title": 'Vacation in Taif City',
      "img": 'https://www.abouther.com/sites/default/files/2020/01/09/mainalhadataifsunset.jpg',
      "location": 'Saudi Arabia - Taif',
      "price": 2000,
      "days": 3,
      "people": 1
    },
    {
      "id": 6,
      "title": 'Vacation in Al Baha City',
      "img": 'https://scth.scene7.com/is/image/scth/sheda_village_1920x1080:crop-760x570?defaultImage=sheda_village_1920x1080',
      "location": 'Saudi Arabia - Al Baha',
      "price": 5000,
      "days": 4,
      "people": 3
    },
    {
      "id": 7,
      "title": 'Vacation in Asir City',
      "img": 'https://media.gettyimages.com/photos/yemen-near-sanaa-asir-mountains-wadi-dhahr-view-of-village-picture-id454126370?s=2048x2048',
      "location": 'Saudi Arabia - Asir',
      "price": 5000,
      "days": 4,
      "people": 2
    },
    {
      "id": 8,
      "title": 'Vacation in Riyadh City',
      "img": 'https://scth.scene7.com/is/image/scth/shutterstock_701002177_6794%20x%203822-1:crop-1160x650?defaultImage=shutterstock_701002177_6794%20x%203822-1',
      "location": 'Saudi Arabia - Riyadh',
      "price": 3000,
      "days": 2,
      "people": 1
    },
  ]
  // new package information added here 
}
export default TDDB;
